import { Map } from 'immutable';

import {
    UPDATE_POI_UPLOAD_STATUS,
    POI_UPLOAD_ERROR,
} from '../actions';

const upload = (state = Map({ totalPages: 0, currentPage: 0, failed: [] }), action) => {
  switch (action.type) {
    case UPDATE_POI_UPLOAD_STATUS:
      return state.set('totalPages', action.payload.totalPages)
                    .set('currentPage', action.payload.currentPage)
    case POI_UPLOAD_ERROR:
      return state.set('failed', [...state.failed, ...action.payload.failed]);
    default:
      return state;
  }
}

export default upload;


// WEBPACK FOOTER //
// ./src/organizations/reducers/upload.js